/**
 * @generated SignedSource<<ded756150df86ab234e6ff26466e383d>>
 * @relayHash 835f1bb695fcc5b988675e09573a32d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 391c9a39bf9b5ba6b25d3c28c0241f0350b8fc1fed7701c8d7fd9c7a83f5dd3b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PolarisProjectArchivedIdeasPageQuery } from './PolarisProjectArchivedIdeasPageQuery.graphql';

const node: PreloadableConcreteRequest<PolarisProjectArchivedIdeasPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "391c9a39bf9b5ba6b25d3c28c0241f0350b8fc1fed7701c8d7fd9c7a83f5dd3b",
    "metadata": {},
    "name": "PolarisProjectArchivedIdeasPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
